import $ from 'jquery';
import resourceSubject from '../reactivity/resource-subject';
import TriggeredGuideManager from './manager';

export default class TriggeredGuide {
  constructor(manager, {
    key, triggerEvent, category, triggerAnchorSelector, triggerShowLater,
  }) {
    this.manager = manager;
    Object.assign(this, {
      key, triggerEvent, category, triggerAnchorSelector, triggerShowLater,
    });
  }

  subscribe() {
    this.subscription = resourceSubject('user-guide').subscribe({
      next: this.handleTriggerEvent.bind(this),
    });
    console.debug(`Guide ${this.key} subscribed event ${this.triggerEvent}`);
  }

  unsubscribe() {
    if (this.subscription) this.subscription.unsubscribe();
    delete this.subscription;
    console.debug(`Guide ${this.key} unsubscribed`);
  }

  remove() {
    this.manager.guides.remove(this);
  }

  handleTriggerEvent(event, details) {
    if (event !== this.triggerEvent) {
      return;
    }

    console.debug(`Capture trigger event: ${event}, details: ${JSON.stringify(details)}`);

    if (!this.anchorElement && this.triggerShowLater) {
      TriggeredGuideManager.saveGuideForShowLater(this);
      console.debug(`save guide ${this.key} for showing later`);
      return;
    }

    this.showGuide().catch(e => console.error(e));
  }

  showGuide() {
    return new Promise((resolve) => {
      if (!this.anchorElement) {
        console.debug(`Can't find anchor with selector ${this.triggerAnchorSelector}, give up showing guide ${this.key}`);
        resolve(false);
        return;
      }
      $.getJSON(`/user_guide_content/${this.key}`).then((result) => {
        if (TriggeredGuide.showingGuideElement()) {
          console.debug(`There's guides already showing, give up showing guide ${this.key}`);
          resolve(false);
          return;
        }

        console.debug(`show guide ${this.key}`);
        const parent = document.querySelector('.page-inner') || document.body;
        parent.insertAdjacentHTML('beforeend', result.content);
        resolve(true);
      });
    });
  }

  static showingGuideElement() {
    return document.querySelector('tr-context-tooltip')
      || document.querySelector('tr-feature-unboxing-video');
  }

  get anchorElement() {
    if (!this.triggerAnchorSelector || this.triggerAnchorSelector === 'document') {
      return document;
    }
    return document.querySelector(this.triggerAnchorSelector);
  }
}
